import React from 'react';

import { Link } from 'react-router-dom';

import PurpleLogo from '@pkg/assets/brand/yat-hand-purple-outline.svg?react';

import './_YatLogo.scss';

const YatLogo = () => {
    return (
        <Link to="/">
            <PurpleLogo />
        </Link>
    );
};

export default YatLogo;
